import { LogoDesktop } from "../Logo";

export default function MenuBrand() {
  return (
    <div className="flex h-20 w-[100px] items-center justify-center py-[19px]">
      <a
        href="/"
        className="flex items-center justify-center"
        aria-label="Go to home"
      >
        <LogoDesktop />
      </a>
    </div>
  );
}
